import { render } from "./ChatUplaodBottom.vue?vue&type=template&id=33585871&scoped=true"
import script from "./ChatUplaodBottom.vue?vue&type=script&lang=js"
export * from "./ChatUplaodBottom.vue?vue&type=script&lang=js"

import "./ChatUplaodBottom.vue?vue&type=style&index=0&id=33585871&lang=scss&scoped=true"
import "./ChatUplaodBottom.vue?vue&type=style&index=1&id=33585871&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33585871"],['__file',"webpack-assets/vue/templates/chat/parts/ChatUplaodBottom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33585871"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33585871', __exports__)) {
    api.reload('33585871', __exports__)
  }
  
  module.hot.accept("./ChatUplaodBottom.vue?vue&type=template&id=33585871&scoped=true", () => {
    api.rerender('33585871', render)
  })

}


export default __exports__